import React, {useState} from "react";
import { GoogleApiWrapper, Map, Marker} from "google-maps-react";



const apiKey = "AIzaSyAkNlfsORaXNSKBPojNkDhHNvVCtdsT3IU";

//This is for create the label for the map

// const [selectedPlace, setSelectedPlace] = useState([]);

// const handleMarkerClick = (parkingLot) => {
//   setSelectedPlace(parkingLot);
// };

// const handleInfoWindowClose = () => {
//   setSelectedPlace(null);
// };



class ParkingMap extends React.Component {

 constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.getAllLots();
  }
  render() {
    return (
      <>
        <Map
          google={this.props.google}
          zoom={12}
          initialCenter={{
            lat: 40.781429682788385,
            lng: -73.97362342255302, // Set initial longitude
          }}
        >
          {/*  This loops through all Parking Lots in the database and puts a pin on the map for them */}
          {this.props.parkingLots.map((parkingLot, index) => (
            <Marker
              key={index}
              name={parkingLot.name}
              position={{
                lat: parkingLot.coordinates[0],
                lng: parkingLot.coordinates[1],
              }}
              //onClick={() => handleMarkerClick(parkingLot)}
            />
          ))}
          
           {/* {selectedPlace && (
            <InfoWindow
              position={{
                lat: selectedPlace.coordinates[0],
                lng: selectedPlace.coordinates[1],
              }}
              onCloseClick={handleInfoWindowClose}
            >
              <div>
                <h3>{selectedPlace.name}</h3>
                <p>{selectedPlace.description}</p>
              </div>
            </InfoWindow>
          )} */}
        </Map>
        {/* <Sidebar /> */}
      </>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: apiKey,
})(ParkingMap);
